import { UNIT_OPTIONS, CURRENCY_OPTIONS, DEFECT_OPTIONS, DEFECT_DETAILED_OPTIONS } from '../../shared/models/list';

import { AllQualityIssueAttachment } from './all-quality-issue-attachment';
import { AllQualityIssueBatch, getQualityIssueBatchQuantity } from './all-quality-issue-batch';
import {
	QualityIssueType,
	QualityIssueStatus,
	QualityIssuePendingPushStatus,
	QualityIssueSample,
} from './all-quality-issue-constants';

export class AllQualityIssue {
	constructor(
		public steeluserId = 0, // the-claim-id
		public id: string | undefined = undefined,
		public personRef = 0,
		public type: QualityIssueType = 'issue',
		public reference = '',
		public statusTr: QualityIssueStatus = QualityIssueStatus.DRAFT,
		public pendingPushStatusTr: QualityIssuePendingPushStatus = QualityIssuePendingPushStatus.CREATE,
		public defectRef: keyof typeof DEFECT_OPTIONS | '' = '',
		public defectDetailedRef: keyof typeof DEFECT_DETAILED_OPTIONS | '' = '',
		public quantityValue = 0,
		public quantityUnitTr: keyof typeof UNIT_OPTIONS = 'to',
		public amountValue = 0,
		public otherCostAmount = 0,
		public amountUnitTr: keyof typeof CURRENCY_OPTIONS = 'eur',
		public sampleTr: QualityIssueSample = 'not',
		public sampleComment = '',
		public shortDescription = '',
		public wantVisit = false,
		public sendSample = false,
		public receivedSupplierReference = '',
		public batches: [AllQualityIssueBatch, ...AllQualityIssueBatch[]] = [new AllQualityIssueBatch()],
		public attachments: AllQualityIssueAttachment[] = [],
		public creationBy = '',
		public creationDate = '',
		public modifBy = '',
		public modifDate = '',
		public claimType: 'ZL' | 'ZR' | null = null,
	) {}

	get haveAdditionalCosts() {
		return this.otherCostAmount !== 0;
	}

	get isDraft() {
		return this.statusTr === QualityIssueStatus.DRAFT;
	}

	get isModifiable() {
		return (
			this.statusTr === QualityIssueStatus.DRAFT
			|| this.statusTr === QualityIssueStatus.PENDING_NOT_PUSH
			|| this.statusTr === QualityIssueStatus.PENDING_PUSH
		)
		&& this.pendingPushStatusTr !== QualityIssuePendingPushStatus.CANCEL;
	}

	setQuantityUnitTr(value: string) {
		const unit = value.toLocaleLowerCase();
		this.quantityUnitTr = unit in UNIT_OPTIONS ? <keyof typeof UNIT_OPTIONS> unit : 'to';
	}

	warnQuantity() {
		const unit = this.batches[0].receivedInvoiceQuantityUnitTr;
		// only if an invoice unit setted
		if (unit !== ''
			// only if different from interface
			&& (
				((unit in UNIT_OPTIONS) && this.quantityUnitTr !== unit)
				|| (!(unit in UNIT_OPTIONS) && this.quantityUnitTr !== 'to')
			)
		) {
			// only if setted
			if (this.quantityValue !== 0) {
				return true;
			}
			this.quantityUnitTr = unit in UNIT_OPTIONS ? unit : 'to';
		}
		return false;
	}

	warnQuantityForTons() {
		// if metric tons check requested quantity
		return this.quantityUnitTr === 'to' && this.quantityValue >= 1000;
	}

	warnForQuantityGtBatchQty() {
		for (const batch of this.batches) {
			// if impacted quantity is greater than total batch quantity.
			if (batch.claimedQuantityValue > getQualityIssueBatchQuantity(batch).value) {
				return true;
			}
		}
		return false;
	}
}

export type FieldOfAllQualityIssue = keyof AllQualityIssue
	| `batches.${ keyof AllQualityIssue['batches'][number] }`
	| `attachments.${ keyof AllQualityIssue['attachments'][number] }`;

export const ALL_ISSUE_FIELDS: FieldOfAllQualityIssue[] = [
	'steeluserId',
	'id',
	'type',
	'reference',
	'statusTr',
	'defectRef',
	'defectDetailedRef',
	'quantityValue',
	'quantityUnitTr',
	'amountValue',
	'amountUnitTr',
	'sampleTr',
	'sampleComment',
	'shortDescription',
	'wantVisit',
	'batches',
	'attachments',
	'creationBy',
	'creationDate',
	'modifBy',
	'modifDate',
	'otherCostAmount',
	'claimType'
];
